import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-indoor-air-quality',
    templateUrl: './indoor-air-quality.component.html',
    styleUrls: ['./indoor-air-quality.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class IndoorAirQualityComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly sideFilterAccessLabel = input<string>(undefined!);
  readonly valueChanged = output<void>();
  airFilterSelection!: GuruEntity;
  airPurificationSelection!: GuruEntity;
  sideFilterAccessSelection!: GuruEntity;
  vocSensorSelection!: GuruEntity;
  particulateMatterSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.INDOOR_AIR_QUALITY;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.airFilterSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFilter');
    this.airPurificationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USAirPurification');
    this.sideFilterAccessSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSideFilterAccess');
    this.vocSensorSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USVOCSensor');
    this.particulateMatterSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPMSensor');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
